import { Component, computed, DestroyRef, inject, input, output, Renderer2, Signal, signal, OnInit } from '@angular/core';
import { followData, followRequest, JobDetails, MoreJobsData } from '../../models/details.model';
import { JobDetailService } from '../../services/job-details.service';
import { Cookies, SharedItem,BdjobsSigninUrl, JobsUrl,} from '../../../../shared/enums/app.enums';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DatePipe, NgClass } from '@angular/common';
import { DateService } from '../../services/date.service';
import { CookieService } from '../../../../core/services/cookie/cookie.service';
import { LocalstorageService } from '../../../../core/services/essentials/localstorage.service';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { ToBanglaNumberPipe } from '../../../../shared/pipes/toBanglaNumber.pipe';
import { environment } from '../../../../../environments/environment';
import { constructRedirectURL } from '../../../jobs/utils/functions';

@Component({
  selector: 'app-more-jobs-modal',
  imports: [NgClass,DatePipe, TranslocoModule, ToBanglaNumberPipe],
  templateUrl: './more-jobs-modal.html',
  styleUrl: './more-jobs-modal.scss'
})
export class MoreJobsModal implements OnInit {
  private jobDetailService = inject(JobDetailService);
  private cookieService = inject(CookieService)
  private localStorageService = inject(LocalstorageService)
  private dateService = inject(DateService)
  private destroyRef = inject(DestroyRef)
  private renderer = inject(Renderer2)
  private transloco = inject(TranslocoService)

  readonly jobList = input<MoreJobsData[]>()
  readonly jobdetails = input<JobDetails | null>({} as JobDetails)
  readonly fromNewspaper = input(false);

  baseUrl = environment.jobDetailsBaseUrl;
  formValue:string = this.cookieService.getCookie(Cookies.MyBDJOBSUSERID) ?? '';
  deviceType:string= SharedItem.DEVICE;
  encoded:string =SharedItem.ENCODED;
  Alias_Status:number =SharedItem.ALIAS_STATUS;

  isFollowedLocal = signal(false)
  followResponse: followData | null = null;
  isFollowed:boolean = false;
  FollowMsg:string='';
  daysRemaining!: Signal<number>;

  closeModalEmt = output<void>()
  
  jobDeadlines = computed(() =>
    this.jobList()?.map((job) => ({
      ...job,
      daysRemaining: this.dateService.getDaysRemaining(job.deadline),
    }))
  );
  ngOnInit(): void {
    this.isFollowedLocal.set(this.localStorageService.getItem("IsFollowed") === 'true' ? true : false);
  }


  closeModal(){
    this.closeModalEmt.emit();
    this.renderer.addClass(document.body, 'overflow-auto');
  }

  follow() {
    const applyRedirectURL = constructRedirectURL('fe', `follow/${this.jobdetails()?.JobId}`, this.transloco.getActiveLang());
    if (typeof this.formValue === 'string' && this.formValue.trim() === '') {
      window.location.href = applyRedirectURL;
      return;
    }
    this.isFollowedLocal.set(this.localStorageService.getItem("IsFollowed") === 'true' ? true : false);
    const followedValue = this.isFollowedLocal() ? 'fed':'fei';
    const payload: followRequest = {
      deviceType: this.deviceType,
      formValue:this.formValue,
      id: this.jobdetails()?.CompanyID || '', 
      actType: followedValue,
      name: this.jobdetails()?.CompnayName || '',
      categoryId:this.jobdetails()?.CategoryID || '',
      jobId:this.jobdetails()?.JobId || ''
    };

    this.jobDetailService.followJob(payload)
    .pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: (data) => this.handleSuccessResponse(data),
      error: () => this.isFollowedLocal.set(this.localStorageService.getItem("IsFollowed") === 'true' ? true : false)
    })
  }

  private handleSuccessResponse(data: followData): void {
    this.followResponse = data;
    if(typeof data ==='string'){
      window.location.href = `${BdjobsSigninUrl}?${data}`;
    }else{
      this.isFollowed = true;
      if(this.isFollowedLocal()){
        this.FollowMsg = "You have removed the employer from your employer list"
      }
      else if(!this.isFollowedLocal){
        this.FollowMsg ="You have successfully followed this employer";
      }
      this.isFollowedLocal.set(!this.isFollowedLocal());
      this.localStorageService.setItem("IsFollowed",this.isFollowedLocal().toString());
    }
  }
}